import { useState } from "react";
import { Menu, Box, MenuItem, Typography } from "@mui/material";
import styles from "../../DataGridTable.module.scss";
import { useNavigate } from "react-router-dom";
import { TableNameItemsInterface } from "components/DataGridTable/DataGridTable";

interface Props {
    tableNameItems?: Array<TableNameItemsInterface>;
    showSearchBtn?: boolean;
}

const TableItemsMenu = ({ tableNameItems, showSearchBtn }: Props) => {
    const navigate = useNavigate();
    let getSelected = (items: any) => items.filter((item: any) => item.link === window.location.pathname)[0];
    const [selectedTableName, setSelectedTableName] = useState(tableNameItems ? getSelected(tableNameItems).label : "");
    const [anchorElTableName, setAnchorElTableName] = useState(null);

    const handleOpenTableNameMenu = (event) => {
        setAnchorElTableName(event.currentTarget);
    };

    const handleCloseTableNameMenu = (item: any) => {
        setSelectedTableName(item.label ? item.label : selectedTableName);
        navigate(item.link);
        setAnchorElTableName(null);
    };

    return (
        <Box sx={{ flexGrow: 0 }}>
            <p
                className={
                    showSearchBtn ? `${styles.tableName} ${styles.deActive}` : `${styles.tableName} ${styles.arrow}`
                }
                style={{ cursor: "pointer" }}
                onClick={handleOpenTableNameMenu}
            >
                {selectedTableName}
            </p>

            <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElTableName}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
                keepMounted
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
                open={Boolean(anchorElTableName)}
                onClose={handleCloseTableNameMenu}
            >
                {tableNameItems.map((item) => (
                    <MenuItem key={item.id} onClick={() => handleCloseTableNameMenu(item)}>
                        <Typography textAlign="center">{item.label}</Typography>
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};

export default TableItemsMenu;
